module.exports = __webpack_public_path__ + "img/settings_640.c69c2526.webp";